var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TwilioSyncStore',{ref:"twilioSyncStore",attrs:{"service":"tcportalAdmin"}}),_c('LoggingStore',{ref:"loggingStore"}),_c('h1',[_vm._v("Function Logging Page")]),_c('FunctionLogging')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }